import React from "react";
import Modal from "../../../../elements/Modal";
import ManageScholarshipTimeline from "../ManageScholarshipTimeline";

const ManageScholarshipTimelineModal = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl" title={data?._id ? "Update Scholarship" : "Create New "}>
      <ManageScholarshipTimeline getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageScholarshipTimelineModal;
